module.exports = __webpack_public_path__ + "img/menu-invoices.6b5931d6.svg";